import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import useUserIp from "hooks/useUserIp";

const useCountries = (options = {}) => {
	const { accessToken } = useTokenStore();
	const { userIp } = useUserIp();

	const getCountries = async () => {
		const instance = await InitApi({ accessToken, userIp });
		const response = await instance.get("/admin/countries");
		return response.data;
	};

	return useQuery("countries", getCountries, {
		staleTime: 30 * 60 * 1000, // 30 minutes
		cacheTime: 60 * 60 * 1000, // 1 hour
		...options,
	});
};

export default useCountries;
